import { useMutation } from "@tanstack/react-query";
import { post } from "../../api/client";
import { RegisterStudentBody } from "../../Constants/Interfaces/payloadInterface/StudentPayload.interface";

export const useRegisterStudent = () =>
  useMutation((body: RegisterStudentBody) => {
    return post({
      url: "api/v1/students/register",
      body: body,
    });
  });
